// extracted by mini-css-extract-plugin
export default {"info":"TableUsers_info__n9HnD","inputWrapper":"TableUsers_inputWrapper__OSAD4","searchIcon":"TableUsers_searchIcon__vISMZ"};